export class Logger {
    onError(e, info) {
        return new Promise((resolve, reject) => {
            // TODO implement it later
            resolve();
        });
    }
}

export const createLogger = () => {
    return new Logger();
};

export default createLogger();
